// ------------------------------------------------
// Customers Store
// ------------------------------------------------
export default {
  namespaced: true,
  state: {
    actionPrivilege: null,
    merchantId: null,
  },
  mutations: {
    SET_ACTION_PRIVILEGE: (state, actionPrivilege) => {
      state.actionPrivilege = actionPrivilege
    },
    SET_MERCHANT_ID: (state, merchantId) => {
      state.merchantId = merchantId
    },
  },
  actions: {
    getActionPrivilege({ commit }, payload) {
      commit('SET_ACTION_PRIVILEGE', payload)
    },
    getMerchantId({ commit }, payload) {
      commit('SET_MERCHANT_ID', payload)
    },
  },
}
